import { jsx as _jsx } from "react/jsx-runtime";
var Volume = function Volume(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.5 18.1016L8.399 14.6036C8.232 14.4906 8.035 14.4286 7.833 14.4286H3.5V9.57159H7.833C8.035 9.57159 8.232 9.50959 8.399 9.39659L13.5 5.89859V18.1016ZM14.966 3.11559C14.637 2.94159 14.24 2.96459 13.935 3.17459L7.523 7.57159H2.5C1.948 7.57159 1.5 8.01859 1.5 8.57159V15.4286C1.5 15.9816 1.948 16.4286 2.5 16.4286H7.523L13.935 20.8256C14.104 20.9416 14.302 20.9996 14.5 20.9996C14.66 20.9996 14.82 20.9616 14.966 20.8846C15.294 20.7116 15.5 20.3716 15.5 19.9996V3.99959C15.5 3.62859 15.294 3.28859 14.966 3.11559ZM18.2793 8.37299C17.9323 7.94299 17.3033 7.87599 16.8733 8.22099C16.4433 8.56699 16.3743 9.19599 16.7203 9.62699C17.7563 10.913 17.7563 13.087 16.7203 14.373C16.3743 14.804 16.4433 15.433 16.8733 15.779C17.0583 15.928 17.2793 16 17.4993 16C17.7913 16 18.0813 15.872 18.2793 15.627C19.9153 13.593 19.9153 10.407 18.2793 8.37299ZM18.2297 5.36249C18.5817 4.93649 19.2127 4.87749 19.6377 5.22949C21.8057 7.02549 22.9997 9.43049 22.9997 12.0005C22.9997 14.5695 21.8057 16.9745 19.6377 18.7705C19.4507 18.9245 19.2247 19.0005 19.0007 19.0005C18.7127 19.0005 18.4277 18.8765 18.2297 18.6375C17.8777 18.2125 17.9367 17.5825 18.3627 17.2295C20.0627 15.8205 20.9997 13.9635 20.9997 12.0005C20.9997 10.0365 20.0627 8.17949 18.3627 6.77049C17.9367 6.41749 17.8777 5.78749 18.2297 5.36249Z",
      fill: !ignoreColor ? color : undefined
    })
  });
};
export default Volume;